export class StartAppLoading {
  static readonly type = '[AppLoading] StartAppLoading';
}

export class StopAppLoading {
  static readonly type = '[AppLoading] StopAppLoading';
}
